import { Button, Flex } from "@unifize/sarah";

type OnboardButtonProps = {
  onClick: () => void;
  disabled: boolean;
  text: string;
};

const OnboardButton = ({ onClick, disabled, text }: OnboardButtonProps) => {
  const isSubmitted = text === "Submitted";

  return (
    <Flex
      justify="center"
      style={{
        paddingTop: "1rem",
      }}
    >
      <Button
        variant="primary"
        onClick={onClick}
        disabled={disabled || isSubmitted}
        {...(isSubmitted
          ? {
              style: {
                backgroundColor: "#E5E7EB",
                color: "#111827",
                borderColor: "#E5E7EB",
                cursor: "not-allowed",
              },
            }
          : disabled
            ? {
                style: {
                  backgroundColor: "#F3F4F6",
                  color: "#6B7280",
                  borderColor: "#E5E7EB",
                  cursor: "not-allowed",
                  opacity: 0.8,
                },
              }
            : {})}
      >
        {text}
      </Button>
    </Flex>
  );
};

export default OnboardButton;
